import {DatabaseCode, toDatabaseCode} from "./database-code";

export type GeofenceType = DatabaseCode;

const circular: GeofenceType = {
  code: 'CIRCULAR',
  displayValue: {
    id: 'ots.ui.entity.geofencetype.circular',
    defaultMessage: 'Circular',
  },
};

const polygon: GeofenceType = {
  code: 'POLYGON',
  displayValue: {
    id: 'ots.ui.entity.geofencetype.polygon',
    defaultMessage: 'Polygon',
  },
};

export const geofenceTypes = {
  circular,
  polygon,
};

export const toGeofenceType = (code: string) => toDatabaseCode(code, Object.values(geofenceTypes));
